import { combineReducers } from "redux";
// import {
//   KRIMonitoringCommand,
//   KRIMonitoringDefault,
//   KRIMonitoringReducer,
// } from "./kri-monitoring/reducer";
// import {
//  KRIRegisterCommand,
//  KRIRegisterDefault,
//  KRIRegisterReducer,
// } from "./kri/reducer";
import {
  UpayaPengelolaanRisikoReducer,
  UpayaPengelolaanRisikoCommand,
  UpayaPengelolaanRisiko,
} from "./upaya-pengelolaan-risiko/reducer";
import {
  PenurunanTingkatRisiko,
  PenurunanTingkatRisikoCommand,
  PenurunanTingkatRisikoReducer,
} from "./penurunan-tingkat-risiko/reducer";
import { HasilEvaluasiMain, HasilEvaluasiCommand, HasilEvaluasiReducer } from "./hasil-evaluasi/reducer"
import { KRIPenilaianMain, KRIPenilaianCommand, KRIPenilaianReducer } from "./kri-penilaian/reducer";
import { ScoringModel } from "./types";
import { Pembobotan, PembobotanCommand, PembobotanReducer } from "./pembobotan/reducer";
import { Kuadran, KuadranReducer, KuadranCommand } from "./kuadran/reducer";
import { ParameterPenilaian, ParameterPenilaianReducer, ParameterPenilaianCommand } from "./parameter-penilaian/reducer";

const ScoringReducer = combineReducers({
  upayaPengelolaanRisiko: UpayaPengelolaanRisikoReducer,
  penurunanTingkatRisiko: PenurunanTingkatRisikoReducer,
  hasilEvaluasi: HasilEvaluasiReducer,
  kriPenilaian: KRIPenilaianReducer,
  pembobotan: PembobotanReducer,
  kuadran: KuadranReducer,
  parameterPenilaian: ParameterPenilaianReducer
  //   kri: KRIRegisterReducer,
});

const Scoring: ScoringModel = {
  upayaPengelolaanRisiko: UpayaPengelolaanRisiko,
  penurunanTingkatRisiko: PenurunanTingkatRisiko,
  hasilEvaluasi: HasilEvaluasiMain,
  kriPenilaian: KRIPenilaianMain,
  pembobotan: Pembobotan,
  kuadran: Kuadran,
  parameterPenilaian: ParameterPenilaian
  //   kri: KRIRegisterDefault,
};

const ScoringCommand = {
  UpayaPengelolaanRisiko: UpayaPengelolaanRisikoCommand,
  PenurunanTingkatRisiko: PenurunanTingkatRisikoCommand,
  HasilEvaluasi: HasilEvaluasiCommand,
  KRIPenilaian: KRIPenilaianCommand,
  Pembobotan: PembobotanCommand,
  Kuadran: KuadranCommand,
  ParameterPenilaian: ParameterPenilaianCommand
  //   kri: KRIRegisterCommand,
};

export { ScoringReducer, Scoring, ScoringCommand };
